import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useToast } from 'context/ToastContext';
import Paginator from 'components/others/Paginator';
import SpinnerBlock from 'components/others/SpinnerBlock';
import { createProcessRun } from 'api/apiTask';
import { useProcessDirList } from '../ProcessDir/model/useProcessDirList';
import ProcessTemplatePicker from './ProcessTemplatePicker';

const PaginatorAny = Paginator as any;

interface NewProcessTemplatePickerProps {
    show: boolean;
    onHide: () => void;
    onCreated: (processId: number) => void;
}

const NewProcessTemplatePicker = ({ show, onHide, onCreated }: NewProcessTemplatePickerProps) => {
    const { t } = useTranslation(['Tasks', 'common']);
    const { showToast } = useToast();
    const [creating, setCreating] = useState(false);
    const picker = useProcessDirList(show);

    const startFromTemplate = async (templateId: number) => {
        setCreating(true);
        const result = await createProcessRun(templateId);
        setCreating(false);
        if (!result?.stat || !result.processId) {
            showToast(t('common:messError'), 'danger');
            return;
        }
        showToast(t('processRuns.messCreatedNotLaunched'), 'warning');
        onCreated(result.processId);
    };

    return (
        <Offcanvas
            show={show}
            onHide={() => !creating && onHide()}
            placement="end"
            backdrop
            backdropClassName="task-dir-offcanvas-backdrop"
            className="task-dir-offcanvas"
        >
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('processRuns.pickTemplate')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-task-dir-form d-flex flex-column h-100">
                    <div className="off-task-dir-content px-3 position-relative">
                        <SpinnerBlock show={creating} onlyBlur />
                        <ProcessTemplatePicker
                            searchInput={picker.searchInput}
                            setSearchInput={picker.setSearchInput}
                            categoryId={picker.categoryId}
                            setFilterCategoryId={picker.setFilterCategoryId}
                            templates={picker.templates}
                            showSpinner={picker.showSpinner}
                            onSelect={(template) => void startFromTemplate(template.ID)}
                        />
                    </div>
                    {picker.paginator ? (
                        <div className="p-3 offcanvas-footer off-task-dir-footer">
                            <PaginatorAny
                                paginator={picker.paginator}
                                storageKey={picker.pageSizeKey}
                                onChangePage={(nextPage: number) => picker.setPage(nextPage)}
                                onChangeOnPage={(nextOnPage: number) => {
                                    picker.setOnPage(nextOnPage);
                                    picker.setPage(1);
                                }}
                            />
                        </div>
                    ) : null}
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default NewProcessTemplatePicker;
